/**
 * Generic ad placement — the single seam an ad network plugs into.
 *
 * The PLACEMENTS are deliberately kept after the AdSense removal. Both
 * consoles still compute eligibility (`shouldShowAds`, guest + free only) and
 * pass an `<AdSlot>` as the panel's `topSlot`, so wiring a replacement network
 * is a change to THIS FILE plus `config/ads.ts` — no console edits, and no
 * re-deriving the tier policy.
 *
 * With no provider configured (`AD_PROVIDER === 'none'`) this renders nothing.
 * Why AdSense was removed, and the sizes a provider should request, are
 * documented in `config/ads.ts`.
 */
import type { AdPlacement } from '../config/ads.ts';

export interface AdSlotProps {
  /** Which on-screen placement this is. */
  readonly placement: AdPlacement;
  /** Panel slots are desktop-only — the mobile inspector has no room. */
  readonly desktopOnly?: boolean;
}

export default function AdSlot(_props: AdSlotProps): null {
  // No provider wired — render nothing at all (no reserved box, no empty
  // container). An unfilled placeholder would waste console height on the
  // exact surfaces where vertical space is scarcest.
  return null;
}
